<template>
  <div class="main-div">
    <div class="bg-main-color1" style="
        padding: 10px;
        color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
      ">
      <div style="flex: 1;">
        <strong>{{ label }}</strong>
        <span v-if="filterBreadcrumb" style="font-weight: normal; opacity: 0.9;">
        <v-icon small class="mr-1" style="vertical-align: middle; opacity: 0.8;">mdi-filter</v-icon>
        {{ filterBreadcrumb }}
</span>

      </div>
      
      <!-- Archive Toggle Button -->
      <!-- <button 
        class="archive-toggle-btn"
        @click="toggleShowArchived"
        :title="showArchived ? 'Hide archived surveys' : 'Show archived surveys'">
        <i :class="showArchived ? 'fa-solid fa-eye-slash' : 'fa-solid fa-archive'"></i>
        {{ showArchived ? 'Hide Archived' : 'Show Archived' }}
      </button> -->
      
      <button class="bg-main-color1" style="color: #fff; margin-left: 10px;" @click.prevent="toggle = !toggle" v-show="!toggle">
        Show
      </button>
      <button class="bg-main-color1" style="color: #fff; margin-left: 10px;" @click.prevent="toggle = !toggle" v-show="toggle">
        Hide
      </button>
    </div>
    <div class="parent" v-show="toggle">
      <!-- Loading State -->
      <div v-if="isLoading" class="loading-container">
        <div class="spinner"></div>
        <p class="loading-text">Loading your surveys...</p>
      </div>

      <!-- No Survey Message -->
      <h3 v-else-if="noSurvey">No tasks assigned to you at this time</h3>

      <!-- Survey Tiles -->
      <div v-else v-for="data in paginatedFilteredSurveys" :key="data.survey_assignment_id" style="cursor: pointer" :class="[
          data.submitted_status == 1 || data.dropped_status == 1
            ? 'child-submitted'
            : data.is_nomination == 1
            ? 'child-nominee'
            : 'child',
          { 'archived-tile': data.archived_status }
        ]">
        
        <!-- TOP SECTION: Text and Logo -->
        <div class="tile-top-section">
          <!-- Archive Icon Button (Top Right) -->
          <!-- <button
            class="archive-icon-btn"
            :class="{ 
              'archived': data.archived_status,
              'archiving': isArchiving[data.survey_assignment_id]
            }"
            @click="openArchiveConfirmation(data.survey_assignment_id, data.archived_status)"
            :disabled="isArchiving[data.survey_assignment_id]"
            :title="data.archived_status ? 'Click to unarchive' : 'Click to archive'">
            <i v-if="!isArchiving[data.survey_assignment_id]" 
               :class="data.archived_status ? 'fa-solid fa-box-open' : 'fa-solid fa-archive'"></i>
            <i v-else class="fa-solid fa-spinner fa-spin"></i>
          </button> -->
          
          <div>
            <h3>{{ data.surveyName }}</h3>
            <h3>{{ data.iterationName }}</h3>
            <h3 v-if="data.subjectFullName != null">
              {{ "For: " + data.subjectFullName }}
            </h3>
            <div>
              <p>{{ data.programName }}</p>
            </div>
            <!-- logo images  -->
            <div v-if="data.survey_type == 1">
              <img class="surveyLogo" src="../../public/survey_logo/big5_survey_logo.png" />
            </div>
            <div v-if="data.survey_type == 6">
              <img class="surveyLogo baseline" src="../../public/survey_logo/baseline_logo.png" />
            </div>
            <div v-if="data.survey_type == 2">
              <img class="surveyLogo" src="../../public/survey_logo/360_survey_logo.png" />
            </div>
            <div v-if="data.survey_type == 3">
              <img class="surveyLogo" src="../../public/survey_logo/research_survey_logo.png" />
            </div>
            <div v-if="data.survey_type == 4 && data.survey_file == 'QSort-BEP.html'">
              <img class="surveyLogo" src="../../public/survey_logo/qSort_BEP.png" />
            </div>
            <div v-if="data.survey_type == 4 && data.survey_file == 'QSort-GDP.html'">
              <img class="surveyLogo" src="../../public/survey_logo/qSort_GDP.png" />
            </div>
            <div v-if="data.survey_type == 4 && data.survey_file == 'QSort-OCM.html'">
              <img class="surveyLogo" src="../../public/survey_logo/qSort_OCM.png" />
            </div>
            <div v-if="data.survey_type == 5">
              <img class="surveyLogo" src="../../public/survey_logo/VFP_logo.png" />
            </div>
            <!-- end of logo images  -->
          </div>
        </div>

        <!-- BOTTOM SECTION: Icons and Buttons -->
        <div class="tile-bottom-section">
          <!-- survey messages icons -->
          <div v-if="data.surveyMessages && data.surveyMessages.length > 0" class="message-icons-container">
            <div class="message-icons">
              <!-- Qualified Icon with Count -->
              <div 
                v-if="getMessageCount(data.surveyMessages, 'Qualified') > 0"
                class="message-icon"
                @click="openMessageModal(data.surveyMessages)"
                :title="'Click to view messages'">
                <i class="fa-solid fa-check icon-qualified"></i>
                <span v-if="getMessageCount(data.surveyMessages, 'Qualified') > 1" class="icon-badge badge-qualified">{{ getMessageCount(data.surveyMessages, 'Qualified') }}</span>
              </div>
              
              <!-- Info Icon with Count -->
              <div 
                v-if="getMessageCount(data.surveyMessages, 'Info') > 0"
                class="message-icon"
                @click="openMessageModal(data.surveyMessages)"
                :title="'Click to view messages'">
                <i class="fa-solid fa-info icon-info"></i>
                <span v-if="getMessageCount(data.surveyMessages, 'Info') > 1" class="icon-badge badge-info">{{ getMessageCount(data.surveyMessages, 'Info') }}</span>
              </div>
              
              <!-- Warning Icon with Count -->
              <div 
                v-if="getMessageCount(data.surveyMessages, 'Warning') > 0"
                class="message-icon"
                @click="openMessageModal(data.surveyMessages)"
                :title="'Click to view messages'">
                <i class="fa-solid fa-triangle-exclamation icon-warning"></i>
                <span v-if="getMessageCount(data.surveyMessages, 'Warning') > 1" class="icon-badge badge-warning">{{ getMessageCount(data.surveyMessages, 'Warning') }}</span>
              </div>
            </div>
          </div>
          <!-- end of survey messages icons -->

          <!-- self assessment  -->
          <div
            v-if="data.survey_type === '1' || data.survey_type === '6' || data.survey_type === '3' || data.survey_type === '4' || data.survey_type === '5'">
            <div v-if="
                data.is_nomination == 0 &&
                data.submitted_status == 0 &&
                data.dropped_status == 0
              ">
              <button :disabled="data.isShow == 'no'" :class="
                  data.isShow == 'no'
                    ? 'btn-disabled btn-take-survey'
                    : 'btn-nominee btn-take-survey'
                " @click="
                  takeSurvey(
                    data.survey_template_link,
                    data.survey_assignment_id,
                    data.ind_id,
                    data.org_id,
                    data.suborg_id,
                    data.subjectFullName,
                    data.survey_template_id,
                    data.iteration_id
                  )
                ">
                Take Survey
              </button>
            </div>
          </div>
          <!-- end of self assessment  -->

          <!-- 360 nomination -->
          <div v-else-if="data.survey_type == 2">
            <div class="d-flex">
              <button :disabled="data.isShow == 'no'" v-if="
                  data.is_nomination == 0 &&
                  data.submitted_status == 0 &&
                  data.dropped_status == 0
                " :class="
                  data.isShow == 'no'
                    ? 'btn-disabled px-25px'
                    : 'btn-nominee px-25px'
                " @click="
                  takeSurvey(
                    data.survey_template_link,
                    data.survey_assignment_id,
                    data.ind_id,
                    data.org_id,
                    data.suborg_id,
                    data.subjectFullName,
                    data.survey_template_id,
                    data.iteration_id
                  )
                ">
                Take Survey
              </button>

              <!-- Solo Make Nomination button (when submitted) -->
              <button :disabled="data.isShow == 'no'" 
                @click="
                  sendProps(
                    data.surveyName,
                    data.survey_assignment_id,
                    data.org_id,
                    data.suborg_id,
                    data.program_id,
                    data.iteration_id,
                    data.stream_id,
                    data.group_id,
                    data.survey_template_id,
                    data.survey_template_association_id,
                    data.ind_id,
                    data.recipient_email
                  )
                " 
                v-if="data.submitted_status == 1 && data.is_nomination == 0 && data.dropped_status == 0"
                :class="[
                  data.isShow == 'no' ? 'btn-disabled' : 'btn-nominee',
                  'solo-nomination',
                  'px-25px'
                ]"
                style="text-align: center;">
                Make Nomination
              </button>

              <!-- Make Nomination button when appearing with Take Survey -->
              <button :disabled="data.isShow == 'no'" 
                @click="
                  sendProps(
                    data.surveyName,
                    data.survey_assignment_id,
                    data.org_id,
                    data.suborg_id,
                    data.program_id,
                    data.iteration_id,
                    data.stream_id,
                    data.group_id,
                    data.survey_template_id,
                    data.survey_template_association_id,
                    data.ind_id,
                    data.recipient_email
                  )
                " 
                v-if="data.submitted_status == 0 && data.is_nomination == 0 && data.dropped_status == 0"
                :class="data.isShow == 'no' ? 'btn-disabled' : 'btn-nominee'">
                Make Nomination
              </button>
            </div>

            <!-- if the indivual is nominee and also participant and not yet submitted the survey -->
            <button :disabled="data.isShow == 'no'" v-show="
                data.is_nomination == 1 &&
                data.submitted_status == 0 &&
                data.dropped_status == 0
              " :class="
                data.isShow == 'no'
                  ? 'btn-disabled btn-take-survey-participant-nominee'
                  : 'btn-nominee btn-take-survey-participant-nominee'
              " @click="
                takeSurvey(
                  data.survey_template_link,
                  data.survey_assignment_id,
                  data.ind_id,
                  data.org_id,
                  data.suborg_id,
                  data.subjectFullName,
                  data.survey_template_id,
                  data.iteration_id
                )
              ">
              Take Survey
            </button>
          </div>
          <!-- end of 360 nomination -->

          <!-- dropped status  -->
          <div v-if="data.dropped_status === 1">
            <button v-if="data.dropped_status === 1" disabled
              class="btn-disabled btn-survey-completed-participant-nominee">
              Dropped
            </button>
          </div>
          <!-- end of dropped status  -->

          <!-- Display Submitted Survey -->
          <div v-if="data.submitted_status == 1">
            <button v-if="
              data.submitted_status == 1 &&
              data.dropped_status == 0
            " :class="data.submitted_status == 0
                    ? 'btn-disabled px-25px'
                    : 'btn-nominee px-25px'
                  " @click="
                  toggleDisplaySubmittedSurvey();
                  adminSurveyView(
                    data.survey_template_link,
                    data.survey_assignment_id,
                    data.ind_id,
                    data.org_id,
                    data.suborg_id,
                    data.subjectFullName,
                    data.survey_template_id,
                    data.iteration_id
                  )
                  ">
              Display Submitted Survey
            </button>
          </div>
          <div class="tooltip" v-if="userId" style="margin-top: 10px">
            Information
            <span class="tooltiptext">- Above this tooltip shows exactly what the participant see in
              their survey tile screen.
              <br />
              <br />- This tooltip and the button under this only shows for Admin
              to view the survey.</span>
          </div>
        </div>
        <!-- end of tile-bottom-section -->
      </div>
      <!-- for loop  -->

      <!-- Pagination -->
      <div v-if="!isLoading && !noSurvey && totalPages > 1" class="pagination-container">
        <button 
          class="pagination-btn" 
          :disabled="currentPage === 1"
          @click="goToPage(currentPage - 1)">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        
        <button 
          v-for="page in displayedPages" 
          :key="page"
          class="pagination-btn"
          :class="{ 'active': page === currentPage }"
          @click="goToPage(page)">
          {{ page }}
        </button>
        
        <button 
          class="pagination-btn" 
          :disabled="currentPage === totalPages"
          @click="goToPage(currentPage + 1)">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
        
        <div class="pagination-info">
          Page {{ currentPage }} of {{ totalPages }} 
          <span v-if="activeFilters">({{ filteredSurveys.length }} filtered / {{ surveyAssignments.length }} total)</span>
          <span v-else>({{ surveyAssignments.length }} total surveys)</span>
        </div>
      </div>
      <!-- End Pagination -->
    </div>
    <!-- parent  -->

    <!-- Message Modal -->
    <div v-if="showMessageModal" class="modal-overlay" @click="closeMessageModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Survey Messages</h3>
          <button class="modal-close" @click="closeMessageModal">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-body">
          <div v-for="(item, index) in currentMessages" :key="index">
            <div v-if="item.survey_message_type && item.survey_message_type != ''" 
              class="modal-message-item"
              :style="{ backgroundColor: getStyle(item.survey_message_type) }">
              <div class="survey-message-container">
                <div class="message-icon-large">
                  <i v-if="item.survey_message_type == 'Qualified'" class="fa-solid fa-check"></i>
                  <i v-if="item.survey_message_type == 'Info'" class="fa-solid fa-info"></i>
                  <i v-if="item.survey_message_type == 'Warning'" class="fa-solid fa-triangle-exclamation"></i>
                </div>
                <div class="message-text">{{ item.survey_message }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Message Modal -->

    <!-- Archive Confirmation Dialog -->
    <!-- <div v-if="showArchiveConfirm" class="modal-overlay" @click="closeArchiveConfirmation">
      <div class="confirm-dialog" @click.stop>
        <div class="confirm-header">
          <i :class="confirmArchiveStatus ? 'fa-solid fa-box-open' : 'fa-solid fa-archive'" 
             class="confirm-icon"></i>
          <h3>{{ confirmArchiveStatus ? 'Unarchive Survey?' : 'Archive Survey?' }}</h3>
        </div>
        <div class="confirm-body">
          <p v-if="!confirmArchiveStatus">
            This survey will be hidden from your main view. You can access it anytime by clicking 
            <strong>"Show Archived"</strong> at the top.
          </p>
          <p v-else>
            This survey will be moved back to your active surveys list.
          </p>
        </div>
        <div class="confirm-actions">
          <button class="btn-cancel" @click="closeArchiveConfirmation">
            Cancel
          </button>
          <button 
            class="btn-confirm" 
            :class="{ 'unarchive': confirmArchiveStatus }"
            @click="confirmArchiveAction">
            <i :class="confirmArchiveStatus ? 'fa-solid fa-box-open' : 'fa-solid fa-archive'"></i>
            {{ confirmArchiveStatus ? 'Unarchive' : 'Archive' }}
          </button>
        </div>
      </div>
    </div> -->
    <!-- End Archive Confirmation Dialog -->
  </div>
  <!-- main-div  -->
</template>

<script>
import api from "../api/api";
import { flashMessage } from "../functions.js";

export default {
  name: "HomeSkillBuilding",
  data: () => ({
    surveyId: "",
    toggle: true,
    surveyAssignments: [],
    noSurvey: false,
    isNominee: false,
    abortController: new AbortController(),
    isDisplaySubmittedSurvey: false,
    isLoading: true,
    showMessageModal: false,
    currentMessages: [],
    currentPage: 1,
    itemsPerPage: 10,
    showArchived: false, // NEW: Toggle for showing archived tiles
    isArchiving: {}, // NEW: Track archiving state for each tile
    showArchiveConfirm: false, // NEW: Show archive confirmation dialog
    confirmArchiveId: null, // NEW: ID of survey to archive
    confirmArchiveStatus: false, // NEW: Current status (for unarchive message)
  }),
  props: {
    reportName: String,
    surveyName: String,
    dateTime: String,
    buttonLabel: String,
    label: String,
    buttonColor: String,
    userData: Object,
    brandData: Object,
    userId: Number,
    runMode: String,
    activeFilters: Object, // RECEIVE FILTERS FROM PARENT
  },
  computed: {
    filterBreadcrumb() {
      if (!this.activeFilters && !this.showArchived) {
        return '';
      }

      const parts = [];
      
      // Show archived status
      if (this.showArchived) {
        parts.push('📦 Archived');
      }
      
      // Organization
      if (this.activeFilters.organization) {
        parts.push(this.activeFilters.organization.name);
        
        // Sub-Organization
        if (this.activeFilters.subOrganization) {
          parts.push(this.activeFilters.subOrganization.name);
          
          // Program
          if (this.activeFilters.program) {
            parts.push(this.activeFilters.program.name);
            
            // Iteration
            if (this.activeFilters.iteration) {
              parts.push(this.activeFilters.iteration.name);
              
              // Stream
              if (this.activeFilters.stream) {
                parts.push(this.activeFilters.stream.name);
                
                // Group
                if (this.activeFilters.group) {
                  parts.push(this.activeFilters.group.name);
                } else {
                  const groupCount = this.activeFilters.stream.groups?.length || 0;
                  if (groupCount > 1) {
                    parts.push('many');
                  }
                }
              } else {
                const streamCount = this.activeFilters.iteration.streams?.length || 0;
                if (streamCount > 1) {
                  parts.push('many');
                }
              }
            } else {
              const iterationCount = this.activeFilters.program.iterations?.length || 0;
              if (iterationCount > 1) {
                parts.push('many');
              }
            }
          } else {
            const programCount = this.activeFilters.subOrganization.programs?.length || 0;
            if (programCount > 1) {
              parts.push('many');
            }
          }
        } else {
          const subOrgCount = this.activeFilters.organization.subOrgs?.length || 0;
          if (subOrgCount > 1) {
            parts.push('many');
          }
        }
      }
      
      return parts.join(' / ');
    },
    filteredSurveys() {
      let surveys = this.surveyAssignments;

      // FILTER OUT ARCHIVED (unless showArchived is true)
      if (!this.showArchived) {
        surveys = surveys.filter(survey => !survey.archived_status);
      }

      if (!this.activeFilters) {
        return surveys;
      }

      return surveys.filter(survey => {
        if (this.activeFilters.organization && 
            survey.org_id !== this.activeFilters.organization.id) {
          return false;
        }

        if (this.activeFilters.subOrganization && 
            survey.suborg_id !== this.activeFilters.subOrganization.id) {
          return false;
        }

        if (this.activeFilters.program && 
            survey.program_id !== this.activeFilters.program.id) {
          return false;
        }

        if (this.activeFilters.iteration && 
            survey.iteration_id !== this.activeFilters.iteration.id) {
          return false;
        }

        if (this.activeFilters.stream && 
            survey.stream_id !== this.activeFilters.stream.id) {
          return false;
        }

        if (this.activeFilters.group && 
            survey.group_id !== this.activeFilters.group.id) {
          return false;
        }

        if (this.activeFilters.searchQuery) {
          const query = this.activeFilters.searchQuery.toLowerCase();
          const fullName = survey.subject_full_name?.toLowerCase() || '';
          const programName = survey.program_name?.toLowerCase() || '';
          const iterationName = survey.iteration_name?.toLowerCase() || '';
          const surveyName = survey.survey_template_name?.toLowerCase() || '';
          
          if (!fullName.includes(query) && 
              !programName.includes(query) && 
              !iterationName.includes(query) &&
              !surveyName.includes(query)) {
            return false;
          }
        }

        return true;
      });
    },

    paginatedFilteredSurveys() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredSurveys.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredSurveys.length / this.itemsPerPage);
    },

    displayedPages() {
      const pages = [];
      const maxVisible = 5;
      
      if (this.totalPages <= maxVisible) {
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (this.currentPage <= 3) {
          for (let i = 1; i <= 4; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(this.totalPages);
        } else if (this.currentPage >= this.totalPages - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = this.totalPages - 3; i <= this.totalPages; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          pages.push(this.currentPage - 1);
          pages.push(this.currentPage);
          pages.push(this.currentPage + 1);
          pages.push('...');
          pages.push(this.totalPages);
        }
      }
      
      return pages;
    },

    showTakeSurvey() {
      return this.surveyAssignments.some(data => 
        data.is_nomination == 0 &&
        data.submitted_status == 0 &&
        data.dropped_status == 0
      );
    }
  },
  watch: {
    // Reset to page 1 when filters change
    activeFilters: {
      handler() {
        this.currentPage = 1;
      },
      deep: true
    },
    // Reset to page 1 when toggling archived view
    showArchived() {
      this.currentPage = 1;
    }
  },
  async mounted() {
    // Set surveyId - if userId is defined (from admin), use it; otherwise use userData.ind_id
    if (this.userId) {
      this.surveyId = this.userId;
    } else {
      this.surveyId = this.userData.ind_id;
    }

    try {
      // Get survey assignments with messages already included
      const res = await api.get(`survey-assignments/individuals/${this.surveyId}`, {  
        signal: this.abortController.signal,  
      });

      this.surveyAssignments = res.data;

      if (this.surveyAssignments.length <= 0) {
        this.noSurvey = true;
        this.isLoading = false;
        return;
      }

      // Process each survey assignment
      this.surveyAssignments.forEach((list) => {
        // Build the survey template link using website_url from API response
        list.survey_template_link = list.survey_file;
        
        // Set display names from the data already in the response
        list.surveyName = list.survey_template_name;
        list.programName = list.program_name;
        list.iterationName = list.iteration_name;
        list.subjectFullName = list.subject_full_name;
        
        // Ensure surveyMessages array exists (it should from API)
        if (!list.surveyMessages) {
          list.surveyMessages = [];
        }
        
        // Ensure archived_status exists (default to false if not in API)
        if (list.archived_status === undefined) {
          list.archived_status = false;
        }
      });

      this.isLoading = false;

    } catch (e) {
      this.isLoading = false;
      if(e.message == 'canceled') {
        return;
      } else {
        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1 ? this.brandData.accent_color1 : "#F47820",
          this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
          e.message
        );
      }
    }
  },
  methods: {
    async toggleArchive(surveyAssignmentId) {
      const survey = this.surveyAssignments.find(
        s => s.survey_assignment_id === surveyAssignmentId
      );
      
      if (!survey) return;

      // Vue 3: just assign directly to the reactive object
      this.isArchiving[surveyAssignmentId] = true;

      try {
        const newStatus = survey.archived_status ? 0 : 1;
        
        await api.put(`survey-assignments/${surveyAssignmentId}/archive`, {
          archived_status: newStatus,
          modified_by: this.surveyId
        });

        survey.archived_status = newStatus;

        const message = newStatus
          ? 'Survey archived successfully'
          : 'Survey unarchived successfully';

        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1 || "#F47820",
          this.brandData.flash_text_color || "#ffffff",
          message
        );

      } catch (error) {
        console.error('Error toggling archive:', error);
        flashMessage(
          this.$flashMessage,
          "#ff0000",
          "#ffffff",
          "Failed to update archive status"
        );
      } finally {
        this.isArchiving[surveyAssignmentId] = false;
      }
    },

    toggleShowArchived() {
      this.showArchived = !this.showArchived;
    },

    openArchiveConfirmation(surveyAssignmentId, currentStatus) {
      this.confirmArchiveId = surveyAssignmentId;
      this.confirmArchiveStatus = currentStatus;
      this.showArchiveConfirm = true;
    },

    closeArchiveConfirmation() {
      this.showArchiveConfirm = false;
      this.confirmArchiveId = null;
      this.confirmArchiveStatus = false;
    },

    confirmArchiveAction() {
      if (this.confirmArchiveId) {
        this.toggleArchive(this.confirmArchiveId);
      }
      this.closeArchiveConfirmation();
    },

    getMessageCount(messages, type) {
      return messages.filter(msg => msg.survey_message_type === type).length;
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        // Scroll to top of survey tiles
        const parentDiv = this.$el.querySelector('.parent');
        if (parentDiv) {
          parentDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
    openMessageModal(messages) {
      // Define sort order: Warning first, Info second, Qualified last
      const sortOrder = { 'Warning': 1, 'Info': 2, 'Qualified': 3 };
      
      this.currentMessages = messages
        .filter(msg => msg.survey_message_type && msg.survey_message_type != '')
        .sort((a, b) => {
          const orderA = sortOrder[a.survey_message_type] || 999;
          const orderB = sortOrder[b.survey_message_type] || 999;
          return orderA - orderB;
        });
      
      this.showMessageModal = true;
    },
    closeMessageModal() {
      this.showMessageModal = false;
      this.currentMessages = [];
    },
    toggleDisplaySubmittedSurvey() {
      this.isDisplaySubmittedSurvey = true;
    },
    getStyle(data) {
      if (data == "Warning") {
        return "rgb(255, 244, 229)";
      } else if (data == "Qualified") {
        return "rgb(237, 247, 237)";
      } else if (data == "Info") {
        return "rgb(232, 244, 253)";
      }
    },
    sendProps(
      surveyName,
      surveyAssignmentID,
      orgID,
      suborgID,
      programID,
      iterationID,
      streamID,
      groupID,
      surveyTemplateID,
      surveyTemplateAssociationID,
      indID,
      recipientEmail
    ) {
      const data = {
        surveyName: surveyName,
        surveyAssignmentID: surveyAssignmentID,
        orgID: orgID,
        suborgID: suborgID,
        programID: programID,
        iterationID: iterationID,
        streamID: streamID,
        groupID: groupID,
        surveyTemplateID: surveyTemplateID,
        surveyTemplateAssociationID: surveyTemplateAssociationID,
        indID: indID,
        recipientEmail: recipientEmail,
      };
      this.$router.push({
        name: "make_nominations",
        params: { data: JSON.stringify(data) },
      });
    },
    takeSurvey(
      survey_template_link,
      survey_assignment_id,
      ind_id,
      org_id,
      suborg_id,
      subjectFullName,
      survey_template_id,
      iteration_id
    ) {
      const data = {
        surveyTemplateLink: survey_template_link,
        surveyAssignmentLink: survey_assignment_id,
        indId: ind_id,
        orgId: org_id,
        suborgId: suborg_id,
        subjectFullName: subjectFullName,
        surveyTemplateId: survey_template_id,
        iteartionId: iteration_id,
        runMode: this.runMode
      };
      this.$router.push({
        name: "MySurvey",
        params: { data: JSON.stringify(data) },
      });
      this.$emit(
        "passSubjectFullName",
        subjectFullName ? subjectFullName : "none"
      );
    },
    adminSurveyView(
      survey_template_link,
      survey_assignment_id,
      ind_id,
      org_id,
      suborg_id,
      subjectFullName,
      survey_template_id,
      iteration_id
    ) 
    {
      if(this.isDisplaySubmittedSurvey === true) {
          const data = {
          surveyTemplateLink: survey_template_link,
          surveyAssignmentLink: survey_assignment_id,
          indId: ind_id,
          orgId: org_id,
          suborgId: suborg_id,
          subjectFullName: subjectFullName,
          surveyTemplateId: survey_template_id,
          iteartionId: iteration_id,
          runMode: "ReadOnly"
        };
        this.$router.push({
          name: "MySurveyAdmin",
          params: { data: JSON.stringify(data) },
        });
        this.$emit(
          "passSubjectFullName",
          subjectFullName ? subjectFullName : "none"
        );
      } else {
          const data = {
          surveyTemplateLink: survey_template_link,
          surveyAssignmentLink: survey_assignment_id,
          indId: ind_id,
          orgId: org_id,
          suborgId: suborg_id,
          subjectFullName: subjectFullName,
          surveyTemplateId: survey_template_id,
          iteartionId: iteration_id,
          runMode: this.runMode
        };
        this.$router.push({
          name: "MySurveyAdmin",
          params: { data: JSON.stringify(data) },
        });
        this.$emit(
          "passSubjectFullName",
          subjectFullName ? subjectFullName : "none"
        );
      }
      this.isDisplaySubmittedSurvey = false
    },
  },
  beforeUnmount() {  
   this.abortController.abort();  
  }, 
};
</script>

<style scoped>
.main-div {
  min-width: 75vw;
  margin: 15px;
}
.parent {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  padding: 10px;
  min-height: 200px;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px;
}
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid v-bind('brandData.accent_color1 ? brandData.accent_color1 : "#b2c225"');
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.loading-text {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
  font-weight: 500;
}
.child {
  border: 1px solid #888;
  border-radius: 10px;
  border-top: 6px solid #0e5071;
  text-align: center;
  font: -webkit-control;
  min-width: 250px;
  max-width: 250px;
  min-height: 380px;
  margin: 0 10px;
  padding: 10px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 2px 4px #ccc;
}
.child:hover {
  border-radius: 2px;
  box-shadow: 5px 8px #ccc;
  transition: all 300ms ease;
}
.child,
.child-submitted,
.child-nominee {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #888;
  border-radius: 10px;
  border-top: 6px solid #0e5071;
  text-align: center;
  min-width: 250px;
  max-width: 205px;
  min-height: 380px;
  margin: 10px;
  padding: 10px;
  box-shadow: 2px 4px #ccc;
}
.child-nominee {
  background-color: #f5f5f5;
}
.child-submitted:hover,
.child-nominee:hover {
  border-radius: 2px;
  box-shadow: 5px 8px #ccc;
  transition: all 300ms ease;
}
.message-icons-container {
  margin: 10px 0 0 0;
  padding: 5px;
}
.message-icons {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
.message-icon {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  position: relative;
}
.message-icon:hover {
  transform: scale(1.2);
}
.icon-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  color: white;
  padding: 0 5px;
  border: 2px solid white;
}
.badge-qualified {
  background-color: #2e7d32;
}
.badge-info {
  background-color: #0277bd;
}
.badge-warning {
  background-color: #f57c00;
}
.icon-qualified {
  color: #2e7d32;
  background-color: rgb(237, 247, 237);
  padding: 10px;
  border-radius: 50%;
}
.icon-info {
  color: #0277bd;
  background-color: rgb(232, 244, 253);
  padding: 10px;
  border-radius: 50%;
}
.icon-warning {
  color: #f57c00;
  background-color: rgb(255, 244, 229);
  padding: 10px;
  border-radius: 50%;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 998;
}
.modal-content {
  background-color: white;
  border-radius: 10px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}
.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}
.modal-close:hover {
  color: #000;
}
.modal-body {
  padding: 20px;
  overflow-y: auto;
}
.modal-message-item {
  padding: 15px;
  margin-bottom: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.modal-message-item:last-child {
  margin-bottom: 0;
}
.survey-message-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.message-icon-large {
  font-size: 20px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.message-text {
  flex: 1;
  font-size: 15px;
  line-height: 1.5;
}
.btn {
  width: 100%;
}
.d-flex {
  display: flex;
}
.btn-nominee {
  background-color: v-bind(
    'brandData.main_color2 ? brandData.main_color2 : "#b2c225"'
  );
  color: v-bind(
    'brandData.button_text_color ? brandData.button_text_color : "#54575B"'
  );
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid rgba(27, 31, 35, 0.15);
  font-weight: 500;
  margin-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 5px;
}
.btn-disabled {
  background-color: #e2e2e2;
  color: #000000;
  border-radius: 20px;
  font-size: 14px;
  border: 1px solid rgba(27, 31, 35, 0.15);
  font-weight: 500;
  margin-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 5px;
}
.btn-nominee:hover {
  text-decoration: none;
  background-color: v-bind(
    'brandData.main_color2 ? brandData.main_color2 : "#b2c225"'
  );
  opacity: 0.8;
  transition-duration: 0.1s;
}
.px-25px {
  padding-left: 25px;
  padding-right: 25px;
}
.btn-survey-completed {
  padding: 14px 55px 14px 55px;
}
.btn-take-survey {
  padding: 14px 55px 14px 55px;
}
.btn-survey-completed-nominee {
  padding: 7px 38px 7px 38px;
}
.btn-survey-completed-participant-nominee {
  padding: 13px 38px 13px 38px;
}
.btn-take-survey-participant-nominee {
  padding: 13px 57px 13px 57px;
}
.surveyLogo {
  width: 150px;
  height: auto;
}
.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: #888;
}
.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
.baseline {
  width: 60%;
  margin-top: 10px;
}
.solo-nomination {
  width: 100% !important;
  padding-left: 25px;
  padding-right: 25px;
}
.pagination-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
  padding: 20px 10px;
  flex-wrap: wrap;
}
.pagination-btn {
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  background-color: white;
  color: #333;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 0 12px;
}
.pagination-btn:hover:not(:disabled):not(.active) {
  background-color: v-bind('brandData.main_color2 ? brandData.main_color2 : "#b2c225"');
  color: v-bind('brandData.button_text_color ? brandData.button_text_color : "#54575B"');
  border-color: v-bind('brandData.main_color2 ? brandData.main_color2 : "#b2c225"');
}
.pagination-btn.active {
  background-color: v-bind('brandData.main_color2 ? brandData.main_color2 : "#b2c225"');
  color: v-bind('brandData.button_text_color ? brandData.button_text_color : "#54575B"');
  border-color: v-bind('brandData.main_color2 ? brandData.main_color2 : "#b2c225"');
  font-weight: 600;
}
.pagination-btn:disabled {
  background-color: #f5f5f5;
  color: #ccc;
  cursor: not-allowed;
  border-color: #e0e0e0;
}
.pagination-info {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}
@media only screen and (min-width: 280px) and (max-width: 540px) {
  .main-div {
    margin: 0 5px 0 5px;
  }
  .modal-content {
    width: 95%;
    max-height: 90vh;
  }
}
.tile-top-section {
  flex: 0 0 auto;
  width: 100%;
  padding-top: 10px;
  position: relative;
}

.tile-bottom-section {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: auto;
}

.message-icons-container {
  margin: 5px 0 0 0;
  padding: 5px;
}

/* Archive Toggle Button in Header */
.archive-toggle-btn {
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 6px 15px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.archive-toggle-btn:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.archive-toggle-btn i {
  font-size: 14px;
}

/* Archive Icon Button (Top Right of Tile) */
.archive-icon-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 26px;
  height: 26px;
  border-radius: 0 8px 0 6px;
  background-color: rgba(108, 117, 125, 0.08);
  border: 1px solid rgba(108, 117, 125, 0.15);
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.3s ease;
  z-index: 10;
  opacity: 0.6;
}

.archive-icon-btn:hover:not(:disabled) {
  opacity: 1;
  background-color: rgba(108, 117, 125, 0.2);
  border-color: rgba(108, 117, 125, 0.4);
  transform: scale(1.1);
}

.archive-icon-btn.archived {
  opacity: 1;
  background-color: rgba(108, 117, 125, 0.3);
  border-color: #6c757d;
  color: #495057;
}

.archive-icon-btn.archived:hover:not(:disabled) {
  background-color: rgba(108, 117, 125, 0.4);
}

.archive-icon-btn:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.archive-icon-btn.archiving {
  opacity: 1;
  background-color: rgba(108, 117, 125, 0.2);
}

/* Archive Confirmation Dialog */
.confirm-dialog {
  background-color: white;
  border-radius: 12px;
  max-width: 440px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.confirm-header {
  padding: 24px 24px 16px 24px;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
}

.confirm-icon {
  font-size: 48px;
  color: #6c757d;
  margin-bottom: 12px;
}

.confirm-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.confirm-body {
  padding: 20px 24px;
}

.confirm-body p {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #666;
  text-align: center;
}

.confirm-body strong {
  color: #333;
  font-weight: 600;
}

.confirm-actions {
  display: flex;
  gap: 12px;
  padding: 16px 24px 24px 24px;
}

.btn-cancel,
.btn-confirm {
  flex: 1;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
}

.btn-cancel {
  background-color: #f5f5f5;
  color: #666;
}

.btn-cancel:hover {
  background-color: #e0e0e0;
  color: #333;
}

.btn-confirm {
  background-color: #6c757d;
  color: white;
}

.btn-confirm:hover {
  background-color: #5a6268;
}

.btn-confirm.unarchive {
  background-color: #28a745;
}

.btn-confirm.unarchive:hover {
  background-color: #218838;
}

.btn-confirm i {
  font-size: 14px;
}

/* Archived Tile Visual Indicator */
.child.archived-tile,
.child-submitted.archived-tile,
.child-nominee.archived-tile {
  opacity: 0.7;
  border-top-color: #6c757d !important;
  background-color: #f8f9fa;
}

.child.archived-tile::before,
.child-submitted.archived-tile::before,
.child-nominee.archived-tile::before {
  content: '📦 ARCHIVED';
  position: absolute;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #6c757d;
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 9px;
  font-weight: bold;
  z-index: 1;
  letter-spacing: 0.5px;
}

/* Make tiles position relative for absolute positioning of archive badge */
.child,
.child-submitted,
.child-nominee {
  position: relative;
}
</style>